module.exports = __webpack_public_path__ + "img/card-border.9e164c9e.svg";